import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RiskItemInformationsVm } from "@shared/models/policy-details";
import { DividerModule } from "primeng/divider";

@Component({
  selector: "app-medical-history-sa",
  standalone: true,
  imports: [CommonModule, TranslateModule, DividerModule],
  templateUrl: "./medical-history-sa.component.html",
})
export class MedicalHistorySaComponent implements OnInit {
  @Input() data!: RiskItemInformationsVm;
  hasHistory = false;
  illnesses: string[] = [];
  ngOnInit(): void {
    this.hasHistory = this.data.values.find(x => x.code == "ANT_ANI")!.value.toLocaleLowerCase() === "true";
    this.illnesses = JSON.parse(this.data.values.find(x => x.code == "MAL_ANI")!.value);
  }
}
